export const CHARGES_EXTENDED_DATE_FORMAT_UI = 'MMMM DD, YYYY';
export const CHARGES_COMPACT_DATE_FORMAT_UI = 'MMM Do';
export const CHARGES_DATE_FORMAT_UI = 'MM/DD/YYYY';
export const CHARGES_SHORT_YEAR = 'MM/DD/YY';
export const SQL_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMATS_ARRAY = [SQL_DATE_FORMAT, CHARGES_DATE_FORMAT_UI];
